import HeartHealth from "./HealthCategories/heart-health.svg?react";
import HormonesHealth from "./HealthCategories/hormones-health.svg?react";
import ImmuneHealth from "./HealthCategories/immune-health.svg?react";
import KidneyHealth from "./HealthCategories/kidney-health.svg?react";
import LiverHealth from "./HealthCategories/liver-health.svg?react";
import MentalHealth from "./HealthCategories/mental-health.svg?react";
import MetabolicHealth from "./HealthCategories/metabolic-health.svg?react";
import MuscleBone from "./HealthCategories/muscle-bone.svg?react";
import NutritionalHealth from "./HealthCategories/nutritional-health.svg?react";

import AdvancedFemaleTestsIcon from "./TestIcons/Advanced-female-tests-icon.svg?react";
import AdvancedHealthTestIcon from "./TestIcons/Advanced-health-test-icon.svg?react";
import AdvancedThyroidTestIcon from "./TestIcons/Advanced-thyroid-test-icon.svg?react";
import BaselineTestIcon from "./TestIcons/Baseline-test-icon.svg?react";
import BespokeTestIcon from "./TestIcons/bespoke-test-icon.svg?react";
import EdgeBespokeTestIcon from "./TestIcons/Edge-bespoke-test-icon.svg?react";
import CortisolTestIcon from "./TestIcons/Cortisol-test-icon.svg?react";
import EnergyTestsIcon from "./TestIcons/Energy-tests-icon.svg?react";
import FemaleTestsIcon from "./TestIcons/Female-tests-icon.svg?react";
import GeneralHealthTestsIcon from "./TestIcons/General-health-tests-icon.svg?react";
import GenericTestIcon from "./TestIcons/generic-test-icon.svg?react";
import EdgeGenericTestIcon from "./TestIcons/Edge-generic-test-icon.svg?react";
import GPConsultationIcon from "./TestIcons/gp-consultation-icon.svg?react";
import HormoneTestsIcon from "./TestIcons/Hormone-tests-icon.svg?react";
import ImmuneHealthTestIcon from "./TestIcons/Immune-health-test-icon.svg?react";
import IronTestIcon from "./TestIcons/Iron-test-icon.svg?react";
import KidneyTestIcon from "./TestIcons/Kidney-test-icon.svg?react";
import LiverTestIcon from "./TestIcons/Liver-test-icon.svg?react";
import MaleTestsIcon from "./TestIcons/Male-tests-icon.svg?react";
import MentalHealthIcon from "./TestIcons/Mental-health-test-icon.svg?react";
import NutritionTestIcon from "./TestIcons/Nutrition-test-icon.svg?react";
import PCOSTestIcon from "./TestIcons/PCOS-test-icon.svg?react";
import TestosteroneTestIcon from "./TestIcons/Testosterone-test-icon.svg?react";
import ThyroidTestIcon from "./TestIcons/Thyroid-test-icon.svg?react";
import UltimateTestIcon from "./TestIcons/Ultimate-test-icon.svg?react";
import VitaminB12TestIcon from "./TestIcons/Vitamin-B12-test-icon.svg?react";
import VitaminDTestIcon from "./TestIcons/Vitamin-D-test-icon.svg?react";
import SexualTestIcon from "./TestIcons/Sexual-tests-icon.svg?react";

import SupplementIcon from "./SupplementIcons/supplement-icon.svg?react";

import DropIcon from "./AppIcons/drop.svg?react";
import PlansIcon from "./AppIcons/plans.svg?react";
import TextLogo from "./AppIcons/text-logo.svg?react";
import EdgeOrangeIcon from "./AppIcons/edge-orange-icon.svg?react";
import ForthIconGradient from "./AppIcons/forth-icon-gradient.svg?react";
import BicepIcon from "./AppIcons/bicep.svg?react";
import EasyToFollow from "./AppIcons/easy-to-follow.svg?react";
import HeartWithCircle from "./AppIcons/heart-with-circle.svg?react";
import MicroscopeIcon from "./AppIcons/microscope.svg?react";
import NutritionOrange from "./AppIcons/nutrition-orange.svg?react";
import ShoppingBag from "./AppIcons/shopping-bag.svg?react";
import ConsultationIcon from "./AppIcons/consultation.svg?react";
import KitIcon from "./AppIcons/kit-icon.svg?react";
import EdgeKitIcon from "./AppIcons/edge-kit-icon.svg?react";
import DoctorIcon from "./AppIcons/doctor-icon.svg?react";
import DoctorHouseIcon from "./AppIcons/doctor-house-icon.svg?react";
import EnvelopeIcon from "./AppIcons/envelope-icon.svg?react";
import GreyHeartCircleIcon from "./AppIcons/grey-heart-circle-icon.svg?react";
import LensCircleIcon from "./AppIcons/lens-circle-icon.svg?react";
import GreyPlansIcon from "./AppIcons/grey-plans-icon.svg?react";
import TubeBubbleIcon from "./AppIcons/tube-bubble-icon.svg?react";
import ThumbsUpIcon from "./AppIcons/thumbs-up-icon.svg?react";
import TubeIcon from "./AppIcons/tube-icon.svg?react";
import VanIcon from "./AppIcons/van-icon.svg?react";
import SubscriptionWheelIcon from "./AppIcons/subscription-wheel.svg?react";
import lightBulb from "./AppIcons/light-bulb.svg?react";
import referralIcon from "./AppIcons/referral-icon.svg?react";
import referralIconEdge from "./AppIcons/edge-referral-icon.svg?react";
import referralIconEdgeV2 from "./AppIcons/v2-edge-referral-icon.svg?react";
import phlebotomyIcon from "./AppIcons/phlebotomy.svg?react";

import KlarnaIcon from "./PaymentIcons/Klarna-icon.svg?react";
import AmexIcon from "./PaymentIcons/amex.svg?react";
import ApplePayIcon from "./PaymentIcons/applepay.svg?react";
import GPayIcon from "./PaymentIcons/gpay.svg?react";
import MasterCardIcon from "./PaymentIcons/mastercard.svg?react";
import VisaIcon from "./PaymentIcons/visa.svg?react";
import StripeIcon from "./PaymentIcons/stripe.svg?react";

import Iso15189 from "./Certificates/iso15189.svg?react";
import Iso13485 from "./Certificates/iso13485.svg?react";
import Iso27001 from "./Certificates/iso27001.svg?react";
import Iso9001 from "./Certificates/iso9001.svg?react";
import Md from "./Certificates/md.svg?react";
import Ce from "./Certificates/ce.svg?react";
import Ivd from "./Certificates/ivd.svg?react";

import Icon404 from "./AppIcons/404-icon.svg?react";
import ImproveHealth from "./AppIcons/ImproveHealth.svg?react";
import EdgeFavicon from "./AppIcons/favicon-transparent.svg?react";
import EdgeWhiteLogo from "./AppIcons/edge-white-logo.svg?react";

import ForthBrandIcon from "../brand/forthBrandIcon.svg?react";
import ForthBrandCopyIcon from "../brand/forthWithCopy.svg?react";
import EdgeBrandIcon from "../brand/forth-edge.svg?react";
import EdgeWhiteBrandIcon from "../brand/forth-edge-white.svg?react";
import {config} from "@/config";

const {websiteId} = config;

export const icons = {
  "404-icon": Icon404,
  "advanced-female-tests-icon": websiteId == 1 || websiteId == 3 ? AdvancedFemaleTestsIcon : EdgeGenericTestIcon,
  "advanced-health-test-icon": websiteId == 1 || websiteId == 3 ? AdvancedHealthTestIcon : EdgeGenericTestIcon,
  "advanced-thyroid-test-icon": websiteId == 1 || websiteId == 3 ? AdvancedThyroidTestIcon : EdgeGenericTestIcon,
  "amex-icon": AmexIcon,
  "applepay-icon": ApplePayIcon,
  "baseline-test-icon": websiteId == 1 || websiteId == 3 ? BaselineTestIcon : EdgeGenericTestIcon,
  "bespoke-test-icon": websiteId == 1 || websiteId == 3 ? BespokeTestIcon : EdgeBespokeTestIcon,
  "bicep-icon": BicepIcon,
  "ce-icon": Ce,
  "consultation-icon": ConsultationIcon,
  "cortisol-test-icon": websiteId == 1 || websiteId == 3 ? CortisolTestIcon : EdgeGenericTestIcon,
  "doctor-house-icon": DoctorHouseIcon,
  "doctor-icon": DoctorIcon,
  "drop-icon": DropIcon,
  "easy-to-follow": EasyToFollow,
  "edge-icon-gradient": EdgeOrangeIcon,
  "favicon-edge": EdgeFavicon,
  "edge-white-logo": EdgeWhiteLogo,
  "energy-tests-icon": websiteId == 1 || websiteId == 3 ? EnergyTestsIcon : EdgeBespokeTestIcon,
  "envelope-icon": EnvelopeIcon,
  "female-tests-icon": websiteId == 1 || websiteId == 3 ? FemaleTestsIcon : EdgeBespokeTestIcon,
  "forth-brand-copy-icon": ForthBrandCopyIcon,
  "forth-brand-icon": ForthBrandIcon,
  "forth-icon-gradient": ForthIconGradient,
  "general-health-tests-icon": websiteId == 1 || websiteId == 3 ? GeneralHealthTestsIcon : EdgeGenericTestIcon,
  "generic-test-icon": websiteId == 1 || websiteId == 3 ? GenericTestIcon : EdgeGenericTestIcon,
  "gp-consultation-icon": GPConsultationIcon,
  "gpay-icon": GPayIcon,
  "grey-heart-circle-icon": GreyHeartCircleIcon,
  "grey-plans-icon": GreyPlansIcon,
  "heart-health": HeartHealth,
  "heart-with-circle": HeartWithCircle,
  "hormone-tests-icon": websiteId == 1 || websiteId == 3 ? HormoneTestsIcon : EdgeGenericTestIcon,
  "hormones-health": HormonesHealth,
  "immune-health-test-icon": websiteId == 1 || websiteId == 3 ? ImmuneHealthTestIcon : EdgeGenericTestIcon,
  "immune-health": ImmuneHealth,
  "improve-health": ImproveHealth,
  "iron-test-icon": websiteId == 1 || websiteId == 3 ? IronTestIcon : EdgeGenericTestIcon,
  "iso13485-icon": Iso13485,
  "iso15189-icon": Iso15189,
  "iso27001-icon": Iso27001,
  "iso9001-icon": Iso9001,
  "ivd-icon": Ivd,
  "kidney-health": KidneyHealth,
  "kidney-test-icon": KidneyTestIcon,
  "kit-icon": websiteId == 1 || websiteId == 3 ? KitIcon : EdgeKitIcon,
  "klarna-icon": KlarnaIcon,
  "lens-circle-icon": LensCircleIcon,
  "light-bulb": lightBulb,
  "liver-health": LiverHealth,
  "liver-test-icon": websiteId == 1 || websiteId == 3 ? LiverTestIcon : EdgeGenericTestIcon,
  "male-tests-icon": websiteId == 1 || websiteId == 3 ? MaleTestsIcon : EdgeGenericTestIcon,
  "mastercard-icon": MasterCardIcon,
  "md-icon": Md,
  "mental-health": MentalHealth,
  "mental-test-icon": MentalHealthIcon,
  "metabolic-health": MetabolicHealth,
  "microscope-icon": MicroscopeIcon,
  "muscle-bone": MuscleBone,
  "nutrition-orange": NutritionOrange,
  "nutrition-test-icon": websiteId == 1 || websiteId == 3 ? NutritionTestIcon : EdgeGenericTestIcon,
  "nutritional-health": NutritionalHealth,
  "pcos-test-icon": websiteId == 1 || websiteId == 3 ? PCOSTestIcon : EdgeGenericTestIcon,
  "plans-icon": PlansIcon,
  "phlebotomy-icon": phlebotomyIcon,
  "referral-icon": referralIcon,
  "edge-referral-icon": referralIconEdge,
  "edge-v2-referral-icon": referralIconEdgeV2,
  "shopping-bag": ShoppingBag,
  "stripe-icon": StripeIcon,
  "subscription-wheel-icon": SubscriptionWheelIcon,
  "supplement-icon": SupplementIcon,
  "testosterone-test-icon": websiteId == 1 || websiteId == 3 ? TestosteroneTestIcon : EdgeGenericTestIcon,
  "text-logo": TextLogo,
  "thumbs-up-icon": ThumbsUpIcon,
  "thyroid-test-icon": websiteId == 1 || websiteId == 3 ? ThyroidTestIcon : EdgeGenericTestIcon,
  "tube-bubble-icon": TubeBubbleIcon,
  "tube-icon": TubeIcon,
  "ultimate-test-icon": websiteId == 1 || websiteId == 3 ? UltimateTestIcon : EdgeGenericTestIcon,
  "van-icon": VanIcon,
  "visa-icon": VisaIcon,
  "vitamin-b12-test-icon": websiteId == 1 || websiteId == 3 ? VitaminB12TestIcon : EdgeGenericTestIcon,
  "vitamin-d-test-icon": websiteId == 1 || websiteId == 3 ? VitaminDTestIcon : EdgeGenericTestIcon,
  "sexual-tests-icon": websiteId == 1 || websiteId == 3 ? SexualTestIcon : EdgeGenericTestIcon,
};
